import React, {
  useCallback,
  useEffect,
  useState,
  Fragment,
  useContext,
} from "react";
import { Divider, IconButton, makeStyles, Typography } from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Box from "@material-ui/core/Box";
import TablePagination from "@material-ui/core/TablePagination";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";
import Axios from "axios";
import Notify from "src/notification/Notify";
import SearchIcon from "@material-ui/icons/Search";
import FilterListIcon from "@material-ui/icons/FilterList";
import Container from "src/layout/Container";
import { UsersData } from "src/ContextAPI";
import VanNewPatient from "./VanNewPatient";
import IsMountedRef from "src/utils/IsMountedRef";
import VanPatientDetails from "./VanPatientDetails";

// import PatientDetails from "./patients/PatientDetails";
// import NewPatient from "./NewPatient";

const imageLocation = process.env.REACT_APP_API_IMAGE;
const useStyles = makeStyles((theme) => ({
  primary: {
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    width: theme.spacing(5),
    height: theme.spacing(5),
  },
}));

const VanPatientList = () => {
  const classes = useStyles();
  const { users } = useContext(UsersData);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedPatient, setSelectedPatient] = useState("new-patient");
  const [search, setSearch] = useState("");
  const [accreditedCompany, setAccreditedCompany] = useState([]);
  const mounted = IsMountedRef();
  const [branchList, setBranchList] = useState({ data: [], ready: false });
  const [selectedCompany, setSelectedCompany] = useState("all");
  const [selectedBranch, setSelectedBranch] = useState("");
  const [displaySearch, setDisplaySearch] = useState(false);
  const [displayFilter, setDisplayFilter] = useState(false);
  const [patient, setPatient] = useState({
    data: [],
    ready: false,
  });

  const getDoctorsPatient = useCallback(() => {
    var params = {
      company: selectedCompany,
      user_id: users.user_id,
      management_id: users.management_id,
      main_mgmt_id: users.main_mgmt_id,
    };
    Axios.get("van/patients/getpatient-list", { params })
      .then((response) => {
        const data = response.data;
        setPatient({ data: data, ready: true });
      })
      .catch((error) => {
        console.log("error: ", error);
      });
  }, [users, selectedCompany]);

  const getAllBranches = React.useCallback(async () => {
    var params = {
      management_id: users.management_id,
      main_management_id: users.main_mgmt_id,
    };
    try {
      let response = await Axios.get("hr/get/all-branches", { params });
      const data = response.data;
      setBranchList({ data, ready: true });
    } catch (error) {
      console.log("error: ", error);
    }
  }, [users]);

  const getAccreditedCompanyList = React.useCallback(async () => {
    let response = await Axios.get("admission/accredited/company/get-list", {
      params: {
        management_id: users.management_id,
        main_mgmt_id: users.main_mgmt_id,
      },
    });

    if (mounted.current) {
      setAccreditedCompany(response.data);
    }
  }, [mounted, users]);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
  };

  const handleClickCompany = (data) => {
    setSelectedCompany(data);
    var params = {
      company: data,
      user_id: users.user_id,
      management_id: users.management_id,
      main_mgmt_id: users.main_mgmt_id,
    };
    Axios.get("van/patients/getpatient-list", { params })
      .then((response) => {
        const data = response.data;
        setPatient({ data: data, ready: true });
      })
      .catch((error) => {
        console.log("error: ", error);
      });
  };

  const handleChangePage = (event, newPage) => {
    event.persist();
    setPage(newPage);
  };

  useEffect(() => {
    getAllBranches();
    getDoctorsPatient();
    getAccreditedCompanyList();
  }, [getAllBranches, getDoctorsPatient, getAccreditedCompanyList]);

  const searchable = patient.data.filter((data) => {
    return (
      data.firstname.toLowerCase().indexOf(search.trim()) !== -1 ||
      data.lastname.toLowerCase().indexOf(search.trim()) !== -1
    );
  });

  return (
    <Fragment>
      <Container
        breadcrumbs={{
          enable: true,
          current: "patient list",
          items: [{ name: "dashboard", path: "/sph/app/registration" }],
        }}
        title={
          <Box display="flex">
            <Box flexGrow={1}>Patient List</Box>
          </Box>
        }
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4} lg={3}>
            <Card>
              <Box
                display="flex"
                justifyContent={"center"}
                alignItems={"center"}
                m={1.5}
              >
                <Box flexGrow={1}>
                  <Typography variant="h6">Patient List</Typography>
                </Box>
                <Box>
                  <IconButton onClick={() => setDisplayFilter(!displayFilter)}>
                    <FilterListIcon fontSize="small" />
                  </IconButton>
                </Box>
                <Box>
                  <IconButton onClick={() => setDisplaySearch(!displaySearch)}>
                    <SearchIcon fontSize="small" />
                  </IconButton>
                </Box>
              </Box>
              <Box mt={1}>
                <Divider />
              </Box>

              <CardContent>
                <Box mb={1} hidden={!displayFilter ? true : false}>
                  <TextField
                    select
                    SelectProps={{ native: true }}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) =>
                      e.target.value === ""
                        ? setSelectedBranch("")
                        : setSelectedBranch(e.target.value)
                    }
                    fullWidth
                    required
                    name="company"
                    label="Company"
                    variant="outlined"
                    // margin="dense"
                    value={selectedBranch}
                  >
                    <option value={""}> All </option>
                    {branchList.data.length > 0 ? (
                      branchList.data.map((data, index) => (
                        <option key={index} value={data.management_id}>
                          {data.label}
                        </option>
                      ))
                    ) : (
                      <option value="" disabled>
                        No Branch found.
                      </option>
                    )}
                  </TextField>
                </Box>

                <Box mb={1} hidden={!displayFilter ? true : false}>
                  <TextField
                    select
                    SelectProps={{ native: true }}
                    onChange={(e) =>
                      e.target.value === "all"
                        ? handleClickCompany("all")
                        : handleClickCompany(e.target.value)
                    }
                    fullWidth
                    required
                    name="company"
                    label="Company"
                    variant="outlined"
                    // margin="dense"
                    value={selectedCompany}
                  >
                    <option value={"all"}> All </option>
                    {accreditedCompany.length > 0 ? (
                      accreditedCompany.map((data, index) => (
                        <option key={index} value={data.company_id}>
                          {data.label}
                        </option>
                      ))
                    ) : (
                      <option value="" disabled>
                        No company found.
                      </option>
                    )}
                  </TextField>
                </Box>
                <Box mb={1} hidden={!displaySearch ? true : false}>
                  <TextField
                    label="Search for patient"
                    variant="outlined"
                    fullWidth
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    // margin="dense"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment>
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>

                <Box>
                  <ListItem
                    button
                    className="mb-2"
                    onClick={() => setSelectedPatient("new-patient")}
                    selected={selectedPatient === "new-patient"}
                  >
                    <ListItemIcon>
                      <Avatar>
                        <strong style={{ fontSize: 30 }}>+</strong>
                      </Avatar>
                    </ListItemIcon>
                    <ListItemText
                      className={`gtc-capitalize`}
                      primary={`Add New Patient`}
                    />
                  </ListItem>
                  {patient.ready ? (
                    searchable.length > 0 ? (
                      <List component="div">
                        {searchable
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          .map((data, index) => (
                            <ListItem
                              key={index}
                              button
                              className="mb-2"
                              onClick={() =>
                                setSelectedPatient(data.patient_id)
                              }
                              selected={selectedPatient === data.patient_id}
                            >
                              <ListItemIcon>
                                {data.image === null ? (
                                  <Avatar className={classes.primary}>
                                    {data.lastname.charAt().toUpperCase()}
                                  </Avatar>
                                ) : (
                                  <Avatar
                                    className={classes.primary}
                                    src={`${imageLocation}patients/${data.image}`}
                                    alt=""
                                  />
                                )}
                              </ListItemIcon>
                              <ListItemText
                                className={`gtc-capitalize`}
                                primary={`${data.lastname}, ${data.firstname} ${
                                  Boolean(data.middle) ? data.middle : ``
                                } `}
                              />
                            </ListItem>
                          ))}
                      </List>
                    ) : (
                      Notify.noRecord()
                    )
                  ) : (
                    Notify.loading()
                  )}
                </Box>

                <TablePagination
                  component="div"
                  count={searchable.length}
                  rowsPerPageOptions={[10, 50, 100]}
                  page={page}
                  onChangePage={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                  labelRowsPerPage="List"
                />
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} sm={8} lg={9}>
            {selectedPatient === "new-patient" ? (
              <VanNewPatient
                accreditedCompany={accreditedCompany}
                getDoctorsPatient={getDoctorsPatient}
              />
            ) : (
              <VanPatientDetails
                selectedBranch={selectedBranch}
                accreditedCompany={accreditedCompany}
                patient_id={selectedPatient}
                getDoctorsPatient={getDoctorsPatient}
              />
            )}
          </Grid>
        </Grid>
      </Container>
    </Fragment>
  );
};

export default VanPatientList;
